<div class="navigation-wrapper">
    <!-- Keen Slider -->
    <div class="keen-slider" #sliderRef>
        <div *ngFor="let community of communityData" class="keen-slider__slide">
            <!-- Conditional wrapping: If link exists, wrap in <a>, otherwise, just use ng-container -->
            <ng-container *ngIf="community.link; else noLink">
                <a [href]="community.link" target="_blank" class="slide-link">
                    <mat-card class="riege-card riege-card--community" appearance="outlined">
                        <mat-card-content class="has-title-icon">
                            <div class="content-header">
                                <div class="mat-card-content__icon">
                                    <mat-icon class="riege-icon md-40" aria-hidden="false" fontIcon="domain"></mat-icon>
                                </div>
                                <mat-card-title> {{ community.title }} </mat-card-title>
                            </div>
                            <div class="community-card__adress-wrapper">
                                <div class="community-card__adress-item">
                                    <mat-icon class="riege-icon md-16">place</mat-icon>
                                    <span>
                                        <span>{{ community.address.street }}</span> <br />
                                        <span>{{ community.address.zip }}</span>
                                        <span>{{ community.address.city }}</span>,
                                        <span>{{ community.address.country }}</span>
                                    </span>
                                </div>
                                <div *ngFor="let service of community.services" class="community-card__adress-item">
                                    <mat-icon class="riege-icon md-16">{{ service.icon }}</mat-icon>
                                    <span>
                                        <span> {{ service.text }} </span>
                                    </span>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </a>
            </ng-container>

            <ng-template #noLink>
                <mat-card class="riege-card riege-card--community" appearance="outlined">
                    <mat-card-content class="has-title-icon">
                        <div class="content-header">
                            <div class="mat-card-content__icon">
                                <mat-icon class="riege-icon md-40" aria-hidden="false" fontIcon="domain"></mat-icon>
                            </div>
                            <mat-card-title> {{ community.title }} </mat-card-title>
                        </div>
                        <div class="community-card__adress-wrapper">
                            <div class="community-card__adress-item">
                                <mat-icon class="riege-icon md-16">place</mat-icon>
                                <span>
                                    <span>{{ community.address.street }}</span> <br />
                                    <span>{{ community.address.zip }}</span>
                                    <span>{{ community.address.city }}</span>,
                                    <span>{{ community.address.country }}</span>
                                </span>
                            </div>
                            <div *ngFor="let service of community.services" class="community-card__adress-item">
                                <mat-icon class="riege-icon md-16">{{ service.icon }}</mat-icon>
                                <span>
                                    <span> {{ service.text }} </span>
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </ng-template>
        </div>
    </div>

    <!-- Left Arrow -->
    <svg
        [ngClass]="'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')"
        (click)="slider?.prev()"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
        <title i18n="@@scope-slider-navigation-previous">Previous</title>
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
    </svg>

    <!-- Right Arrow -->
    <svg
        *ngIf="slider"
        [ngClass]="'arrow arrow--right ' + (slider.track.details.maxIdx === currentSlide ? 'arrow--disabled' : '')"
        (click)="slider.next()"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
        <title i18n="@@scope-slider-navigation-next">Next</title>
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </svg>

    <!-- Dots (Pagination) -->
    <!-- <div class="dots">
        <button
            (click)="slider?.moveToIdx(i)"
            *ngFor="let slide of dotHelper; let i = index"
            [class]="'dot ' + (i === currentSlide ? 'active' : '')"
            [attr.aria-label]="'Go to slide ' + (i + 1)">
        </button>
    </div> -->
</div>
